import Visualization from './Visualization';

export default Visualization;
